import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closePostResultsModal, selectIsPostResultsModalOpen } from "../model"
import { fetchPostResults } from "../model/update-marketing-campaigns-thunk"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from 'yup'
import { FormInput } from "@/shared/ui/form-input"
import { selectChannels } from "@/entities/marketing-campaign"
import { useMemo } from "react"

interface CreateInvitationFormValues {
    chatId?: number
}

const initialState: CreateInvitationFormValues = {}


const postResultsValidationSchema = yup.object().shape({
    chatId: yup.number().typeError('Выберите канал').required('Выберите канал')
})

export const PostMarketingCampaignResultsModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsPostResultsModalOpen)
    const channels = useAppSelector(selectChannels)
    
    const channelsSelectOptions = useMemo(() => {
        return channels.map((channel) => ({
            value: channel.telegramId,
            label: channel.name
        }))
    }, [channels])

    const handleClose = () => {
        dispatch(closePostResultsModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
            dispatch(fetchPostResults({
                chatId: data.chatId
            }))
                .unwrap()
                .then(() => {
                    notify.success('Результаты розыгрыша успешно отправлены')
                    reset()
                    res('')
                    handleClose()
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        control,
        register,
        formState: { errors, isSubmitting },
        reset
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(postResultsValidationSchema)
    })

    return (
        <Modal
            isOpen={isOpen}
            title="Рассылка резултатов розыгрыша"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    label={"Канал"}
                    id={"chatId"}
                    error={errors['chatId']}
                    options={channelsSelectOptions}
                    control={control}
                    type="select"
                    required={true}
                    placeholder="Выберите канал оповещения"
                />
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} type="button" className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Далее
                    </button>
                </div>
            </form>
        </Modal>
    )
}